export const PRINTLABEL_INDIVIDUALPRINT_REQUEST =
  "PRINTLABEL_INDIVIDUALPRINT_REQUEST";
export const PRINTLABEL_INDIVIDUALPRINT_SUCCESS =
  "PRINTLABEL_INDIVIDUALPRINT_SUCCESS";
export const PRINTLABEL_INDIVIDUALPRINT_FAILURE =
  "PRINTLABEL_INDIVIDUALPRINT_FAILURE";

export const PRINTLABEL_PACKAGEPRINT_REQUEST =
  "PRINTLABEL_PACKAGEPRINT_REQUEST";
export const PRINTLABEL_PACKAGEPRINT_SUCCESS =
  "PRINTLABEL_PACKAGEPRINT_SUCCESS";
export const PRINTLABEL_PACKAGEPRINT_FAILURE =
  "PRINTLABEL_PACKAGEPRINT_FAILURE";


